import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './art.component.html',
  styleUrls: ['./art.component.scss']
})
export class ArtComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
